import { MESApiService, type spParameter } from "../services";

export const getUser = async (UserId: number, UserName: string | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: UserId });
	parameters.push({ name: "UserName", value: UserName });

	const resp = await apiService.callV2("[SEC].[GetUser]", parameters);
	return resp;
};

export const getAssets = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetAssets]", []);
	return resp;
};

export const getUTLSettings = async () => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[UTL].[GetSettings]", []);
	return resp;
};

export const upsertDefaultAreaId = async (
	UserId: number,
	DefaultAreaId: number | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "UserId", value: UserId });
	parameters.push({ name: "DefaultAssetId", value: DefaultAreaId });

	const resp = await apiService.callV2(
		"[SEC].[UpsertDefaultAssetId]",
		parameters,
	);
	return resp;
};
